import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Link from '../Link';
import { getCookie, setCookie } from '../../cookies';
import horizontallyCenteredSection from '../styles/horizontallyCenteredSection';

export const COOKIES_POLICY_BANNER = 'artema_corp__cookies_policy_banner';

const CookiesPolicyBannerStyles = styled.div`
  ${horizontallyCenteredSection}
  position: sticky;
  bottom: 0;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--color-black);
  font-size: 2rem;
  background-color: var(--color-fluor-green);
  z-index: var(--z-index-high);

  a {
    color: var(--color-black);
  }

  p {
    margin: 0 0 1.5rem;
  }

  button {
    height: 3.5rem;
    min-width: 10rem;
    font-size: 1.5rem;
    font-weight: bold;
    border-radius: 0.5rem;
    background-color: transparent;
    border: 2px solid var(--color-black);
    cursor: pointer;
  }

  @media (min-width: 768px) {
    min-height: 12.5rem;
    flex-direction: row;
    align-items: center;

    p {
      margin: 0;
    }

    button {
      margin-left: 5rem;
    }
  }
`;

export default function CookiesPolicyBanner() {
  const [isVisible, setIsVisible] = useState(false);

  const setCookiesBannerShown = () => {
    setCookie(COOKIES_POLICY_BANNER, true);
    setIsVisible(false);
  };

  useEffect(() => {
    const wasCookiesBannerShown = !getCookie(COOKIES_POLICY_BANNER);
    setIsVisible(wasCookiesBannerShown);
  });

  if (!isVisible) {
    return null;
  }

  return (
    <CookiesPolicyBannerStyles>
      <p>
        This website uses cookies, if that’s okay, just keep browsing. Click{' '}
        <Link to="/cookies">here</Link> if you want to know more.
      </p>
      <button
        type="button"
        className="close-button"
        onClick={setCookiesBannerShown}
      >
        ACCEPT
      </button>
    </CookiesPolicyBannerStyles>
  );
}
